import { SERVICES } from "@/data/services";
import { ArrowRight } from "lucide-react";

export default function Services() {
  const scrollToBook = (serviceName) => {
    const select = document.querySelector('[data-service-prefill]');
    if (select) select.setAttribute("data-service-prefill", serviceName);
    window.dispatchEvent(new CustomEvent("prefill-service", { detail: serviceName }));
    document.getElementById("book")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="services" className="py-20 lg:py-28 bg-slate-50" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <p className="text-sm uppercase tracking-widest text-accent font-semibold mb-3">What We Do</p>
          <h2 className="text-3xl md:text-4xl font-display font-bold tracking-tight text-slate-900">
            Anything Your Commercial Property Needs – We've Got You Covered.
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            Installation, maintenance and repairs across the board — handled by a single accountable team.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <button
                key={s.id}
                onClick={() => scrollToBook(s.name)}
                data-testid={`service-card-${s.id}`}
                className="group text-left bg-white border border-slate-200 rounded-lg p-6 hover:-translate-y-1 hover:shadow-md hover:border-accent/40 transition-all duration-200"
              >
                <div className="h-12 w-12 rounded-lg bg-blue-50 flex items-center justify-center mb-4 group-hover:bg-accent transition-colors">
                  <Icon className="h-6 w-6 text-accent group-hover:text-white transition-colors" strokeWidth={1.5} />
                </div>
                <h3 className="font-display font-semibold text-lg text-slate-900 mb-1.5">{s.name}</h3>
                <p className="text-sm text-slate-500 leading-relaxed">{s.blurb}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-accent opacity-0 group-hover:opacity-100 transition-opacity">
              Book This <ArrowRight className="h-3.5 w-3.5" />
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
